<template>
  <div>
    <training-toolbar v-if="userInfo"/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo"
        :title="$t('parametrics.criteriasTitle')"
        :iconName="'folder'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <template v-if="showAddCriteria">
          <criteria-form :allModules="allModules"
            v-on:error:api.capture="handleError" @hide-add-criteria="showAddCriteria= false" @refresh-list="refreshList"/>
        </template>

        <b-row v-if="allModules">
          <b-form-group
            id="input-eval-type"
            :label="$t('parametrics.evalType')"
            label-for="eval-type"
            label-align="left"
            class="col-3"
          >
            <b-form-select
              id="eval-type"
              v-model="evalType" 
              :options="evaluationTypes"
              @change="typeChanged">

            </b-form-select>
          </b-form-group>
          <b-form-group
            v-if="evalType == 'MODULE'"
            id="input-module"
            :label="$t('parametrics.module')"
            label-for="module"
            label-align="left"
            class="col-md-7 col-lg-6"
          >
            <v-select
              id="module"
              :options="allModules"
              placeholder="Όλες"
              :clearable='true'
              label="title"
              v-model="selectedModule"
              class="bg-white rounded"
              @input="getCriterias()"
            >
              <template #no-options="{ }">
                {{ $t("parametrics.noRequiredModulesToAdd") }}
              </template>
            </v-select>
          </b-form-group>
          <b-button class="esep-blue-bg my-auto ml-auto mr-3" variant="primary" @click="showAddCriteria= true" v-if="!showAddCriteria">
            {{ $t("parametrics.addCriteria") }}
          </b-button>
        </b-row>
        <hr />

        <template v-if="criterias">
          <criterias-table :criterias="criterias" :module="selectedModule" :evalType="evalType" 
            v-on:error:api.capture="handleError" @refresh-list="refreshList"/>
        </template>

      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import CriteriasTable from "../../components/parametrics/criteriasTable";
import CriteriaForm from '../../components/parametrics/criteriaForm.vue';
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";

export default {
  components: {
    CardHeader,
    TrainingToolbar,
    CriteriasTable,
    CriteriaForm
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.training.parametrics)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.getAllModules();
    this.getCriterias();
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      evalType: 'MODULE',
      evaluationTypes: [
        { value: 'MODULE', text: this.$t('evaluationTypeEnums.MODULE') },
        { value: 'SESSION', text: this.$t('evaluationTypeEnums.SESSION') },
        { value: 'TRAINER', text: this.$t('evaluationTypeEnums.TRAINER') }
      ],
      allModules: null,
      criterias: null,
      selectedModule: null,
      showAddCriteria: false
    }
  }, 
  watch: {
    showAddCriteria() {
      window.scroll(0,0);
    }
  },
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    },
    getAllModules() {
      trainingService.getModulesByCriteria(true).then(
        (response) => {
          this.$log.debug("modules")
          this.$log.debug(response.data);
          let modules = response.data;
          modules.unshift({id: null , title: "Όλες"});
          this.allModules = modules;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    getCriterias() {
      let type = 'leader';
      let id = null;
      if(this.evalType == 'MODULE') {
        type = 'module';
        id = this.selectedModule?.id;
      } else if(this.evalType == 'SESSION') {
        type = 'session';
      }
      trainingService.getCriterias(type, id).then(
        (response) => {
          this.$log.debug("criterias")
          this.$log.debug(response.data);
          this.criterias = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    typeChanged() {
      this.getCriterias();
    },
    refreshList(message = null) {
      this.getCriterias();
      this.showAddCriteria = false;
      this.successMessage = message;
      this.popSuccessAlert = true;
      window.scroll(0,0);
    }
  },
}
</script>